import { render, staticRenderFns } from "./SectionAlertSidebar.vue?vue&type=template&id=103b847e&"
import script from "./SectionAlertSidebar.vue?vue&type=script&lang=js&"
export * from "./SectionAlertSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports